import { useCallback, useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Badge from "@mui/material/Badge";
import ToolbarButton from "../common/Toolbar-button";
import AppModal from "../common/AppModal";
import AppSnackbar from "../common/AppSnackbar";
import SearchField from "../common/SearchField";
import { IconButton } from "@mui/material";
import AssignShiftContent from "./assign-shift-content";
import { useAppSelector } from "../../app/hooks";
import FilterIcon from "../../assets/icon/filter.svg";
import { FilterPopover } from "./filter-popover";
import { styles } from "./styles";

export const ShiftListToolbar = ({ setFilterValuesParent, dropDownOptions, onSearch, employeeNames, bubbleNumber }: any) => {
  const [openModal, setOpenModal] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [assignShiftMember, setAssignShiftMember] = useState("");
  const [filterValues, setFilterValues] = useState({
    dropdown1: null,
    dropdown2: null,
    dropdown3: null,
    dropdown4: null,
    date: undefined,
  });
  const handleDropdownChange = (key: string) => (event: any, value: any) => {
    setAssignShiftMember(value);
  };
  const {
    isAddShiftDutySuccess,
    isAddShiftDutyLoading
  }: any = useAppSelector((state) => state.shift);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const [searchQuery, setSearchQuery] = useState("");


  useEffect(() => {
    if (!isAddShiftDutyLoading)
      if (isAddShiftDutySuccess)
        setOpenModal(false);
  }, [isAddShiftDutySuccess])

  const handleSearchChange = useCallback((searchQuery: string) => {
    setSearchQuery(searchQuery);
    onSearch(searchQuery);
  }, [onSearch]);

  return (
    <Box>
      <Box
        sx={styles.toolbarContainer}
      >
        <SearchField width={292} searchQuery={searchQuery} setSearchQuery={handleSearchChange} title={"Search Name"}  />
        <Box sx={styles.filterBox}>
          <ToolbarButton title="Add Shift" height={"36px"} fontSize={"16px"} disabled={employeeNames?.length === 0} handleOpenModal={handleOpenModal} />
          <IconButton onClick={(event) => setAnchorEl(event.currentTarget)} style={styles.filterIcon}>
            <Badge
              badgeContent={bubbleNumber}
              color="primary"
              invisible={bubbleNumber === 0 || bubbleNumber === undefined || bubbleNumber === null} // Only show badge if there are filters
            >
              <img src={FilterIcon} alt="Filter Icon" />
            </Badge>
          </IconButton>
          <FilterPopover
            dropDownOptions={dropDownOptions}
            filterValues={filterValues}
            setFilterValues={setFilterValues}
            setFilterValuesParent={setFilterValuesParent}
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
          />
        </Box>
        <AppModal
          title="Assign Shift"
          open={openModal}
          handleClose={handleCloseModal}
          fullScreen={false}
          maxWidth="md"
        >
          <AssignShiftContent
            listMembers={employeeNames}
          />
        </AppModal>
      </Box>
      <AppSnackbar
        message="Successfully Registered!"
        open={openSnackbar}
        handleClose={() => setOpenSnackbar(false)}
      />
    </Box>
  );
};
